export default "__VITE_ASSET__DOsY5EIP__"